var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _g, _path8, _rect3, _g2, _path9, _path10, _rect4, _g3, _path11, _rect5, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeakerTube5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 239,
    viewBox: "0 0 140 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.397 92.5829C116.747 93.916 115.212 94.6006 113.767 94.2043L111.853 93.6638C106.5 96 106 98 105.839 105V232.839C105.839 236.208 103.094 238.946 99.7163 238.946L30.4562 239C27.061 239 24 236.498 24 233.129V87C24 84.55 23.5934 82.3685 22.2209 80.3148C21.4985 78.7655 22.6363 77 24.352 77H95.689C103.401 77 110.769 80.1526 116.079 85.7012C118.011 87.4487 118.553 90.259 117.397 92.5829Z",
    fill: "#D9ECF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8751 178L98.1422 177.949C101.373 177.949 104 175.341 104 172.133V110.5C76.1972 109.539 61.5 105.5 26 105.5V172.167C26 175.392 28.6265 178 31.8751 178Z",
    fill: "#33BEF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1149 122.948H28.7767C28.1085 122.948 27.5667 123.488 27.5667 124.155C27.5667 124.821 28.1085 125.362 28.7767 125.362H54.1149C54.7831 125.362 55.3249 124.821 55.3249 124.155C55.3249 123.488 54.7831 122.948 54.1149 122.948Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 115V229.165C26 232.401 28.6242 235.017 31.8699 235L98.0783 234.948C101.307 234.948 104 232.219 104 229V107C104 106.415 103.965 105.585 104 105C76.757 105.258 64 115 26 115Z",
    fill: "#66CEF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7024 113H38.2976C37.0274 113 36 114.149 36 115.569V231.638C36 233.496 37.345 235 39.0075 235H47.9925C49.655 235 51 233.496 51 231.638V115.569C51 114.149 49.9726 113 48.7024 113Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 228.051C30 228.578 30.4445 229 31 229C31.0743 229 31.1466 228.993 31.2161 228.978C31.2822 228.993 31.3508 229 31.4212 229H39.8191C40.3429 229 40.7763 228.556 40.7944 228C40.7944 227.445 40.3609 227 39.8191 227H32V213H39.8191C40.3429 213 40.7763 212.556 40.7944 212C40.7944 211.444 40.3609 211 39.8191 211H32V197H39.8191C40.3429 197 40.7763 196.556 40.7944 196C40.7944 195.445 40.3609 195 39.8191 195H32V181H39.8191C40.3429 181 40.7763 180.556 40.7944 180C40.7944 179.445 40.3609 179 39.8191 179H32V165H39.8191C40.3429 165 40.7763 164.556 40.7944 164C40.7944 163.445 40.3609 163 39.8191 163H32V149H39.8191C40.3429 149 40.7763 148.556 40.7944 148C40.7944 147.445 40.3609 147 39.8191 147H32V133H39.8191C40.3429 133 40.7763 132.556 40.7944 132C40.7944 131.445 40.3609 131 39.8191 131H32V117H39.8191C40.3429 117 40.7763 116.556 40.7944 116C40.7944 115.445 40.3609 115 39.8191 115H32V101H40.3731C40.8968 101 41.3303 100.556 41.3483 100C41.3483 99.4445 40.9149 99.0001 40.3731 99.0001H31.9752C31.8021 99.0001 31.64 99.0454 31.4996 99.1253C31.353 99.0455 31.1825 99.0001 31 99.0001C30.4445 99.0001 30 99.4218 30 99.949V228.051Z",
    fill: "#668BA6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3461 79H28.7872C28.1132 79 27.5667 79.4478 27.5667 80C27.5667 80.5523 28.1132 81 28.7872 81H54.3461C55.0201 81 55.5667 80.5523 55.5667 80C55.5667 79.4478 55.0201 79 54.3461 79Z",
    fill: "white",
    fillOpacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.0443,
    y: 131,
    width: 18,
    height: 43.1906,
    rx: 9,
    transform: "rotate(-90 44.0443 131)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8222_36601",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 115,
    width: 39,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.0532,
    y: 129,
    width: 13.7692,
    height: 38.1684,
    rx: 6.88458,
    transform: "rotate(-90 46.0532 129)",
    fill: "#99DFF9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8222_36601)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.0532,
    y: 129,
    width: 13.7692,
    height: 39.1471,
    rx: 6.88458,
    transform: "rotate(-90 46.0532 129)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9378 127.279C49.1355 127.279 46.0532 124.197 46.0532 120.394C46.0532 116.592 49.1355 113.51 52.9378 113.51L85.2003 113.51L85.2003 123.279C85.2003 125.488 83.4095 127.279 81.2003 127.279L52.9378 127.279Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0443 117L44.0443 114L85.2261 114L85.2261 117L44.0443 117Z",
    fill: "#F2F7FC"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1165 126.035C37.459 126.542 36.5061 126.073 36.5061 125.243L36.5061 119.204C36.5061 118.407 37.3924 117.93 38.0572 118.369L42.1449 121.069L42.1449 122.931L38.1165 126.035Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8222_36601",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 119,
    width: 3,
    height: 6
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.651,
    y: 119.828,
    width: 4.34483,
    height: 2.50609,
    rx: 1.25304,
    transform: "rotate(90 44.651 119.828)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8222_36601)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.651,
    y: 119.828,
    width: 4.34483,
    height: 2.50609,
    rx: 1.25304,
    transform: "rotate(90 44.651 119.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8492 119.207C43.1719 119.207 43.4518 119.426 43.5083 119.744C43.5985 120.25 43.7112 121.069 43.7112 122C43.7112 122.931 43.5985 123.75 43.5083 124.256C43.4518 124.574 43.1719 124.793 42.8492 124.793C42.4602 124.793 42.1449 124.478 42.1449 124.089L42.1449 119.911C42.1449 119.522 42.4602 119.207 42.8492 119.207Z",
    fill: "#EEEEEE"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3561 125.518C34.7015 125.767 34 125.284 34 124.583L34 119.936C34 119.265 34.6491 118.784 35.2916 118.98L42.1449 121.069L42.1449 122.931L35.3561 125.518Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1628 126.035C93.8203 126.542 94.7731 126.073 94.7731 125.243L94.7731 119.204C94.7731 118.407 93.8869 117.93 93.222 118.369L89.1344 121.069L89.1344 122.931L93.1628 126.035Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8222_36601",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 119,
    width: 4,
    height: 6
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.50609,
    rx: 1.25305,
    transform: "matrix(4.56633e-08 1 1 -4.17372e-08 86.6283 119.828)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8222_36601)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.50609,
    rx: 1.25305,
    transform: "matrix(4.56633e-08 1 1 -4.17372e-08 86.6283 119.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.43 119.207C88.1074 119.207 87.8275 119.426 87.771 119.744C87.6808 120.25 87.5681 121.069 87.5681 122C87.5681 122.931 87.6808 123.75 87.771 124.256C87.8275 124.574 88.1074 124.793 88.43 124.793C88.8191 124.793 89.1344 124.478 89.1344 124.089L89.1344 119.911C89.1344 119.522 88.8191 119.207 88.43 119.207Z",
    fill: "#EEEEEE"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9232 125.518C96.5777 125.767 97.2793 125.284 97.2793 124.583L97.2793 119.936C97.2792 119.265 96.6302 118.784 95.9877 118.98L89.1344 121.069L89.1344 122.931L95.9232 125.518Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 113,
    width: 18,
    height: 12,
    transform: "rotate(90 72 113)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(58.5 116.5)",
    fill: "#333333",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Bio Sans",
    fontSize: 12,
    letterSpacing: "0px"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 4.39062,
    y: 9.7
  }, "5"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeakerTube5);
export default __webpack_public_path__ + "static/media/Beaker_Tube5.3f4cc49f5eed9d67e10dc046a119cc37.svg";
export { ForwardRef as ReactComponent };